import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SessionModel } from '../models/session';

type SessionSliceState = {
  data?: SessionModel;
  error?: string;
  loading: boolean;
};

const initialState: SessionSliceState = {
  data: undefined,
  error: undefined,
  loading: false,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    getSessionStart: (state: SessionSliceState) => {
      state.loading = true;
    },
    getSessionSuccess: (state: SessionSliceState, action: PayloadAction<SessionModel>) => {
      state.loading = false;
      state.data = action.payload;
    },
    getSessionFailure: (state: SessionSliceState, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getSessionStart, getSessionSuccess, getSessionFailure } = sessionSlice.actions;
